import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useDidMount } from '../../../../../../../hooks/life-cycle';
import { EditPC } from '../../../../../../dialogs/edit/edit.pc';
import { MasterEditDialogProps } from '../../../master.type';
import { Input } from '../../../../../../ui/input/input';
import { Required } from '../../../../../../ui/required/required';
import { RightLabelCheckbox } from '../../../../../../ui/checkbox/right-label-checkbox/right-label-checkbox';
import { ColorPicker } from '../../../../../../ui/color-picker/color-picker';
import { useAppSelector } from '../../../../../../../hooks/use-redux';
import { MasterActions } from '../../../../../../../redux/master/master.action';
import { DialogActions } from '../../../../../../../redux/dialog/dialog.action';
import { MasterCustomerExpectedRankValidation } from '../../../../../../../model/validation/master/master-customer-expected-rank.validation';
import { Message } from '../../../../../../../collection/message.collection';
import { ValidationEisuzi } from '../../../../../../../model/validation/validation-eisuzi';

export const CustomerExpectedRankMasterEditDialog = (props: MasterEditDialogProps) => {
  const { id, callback } = props;
  const dispatch = useDispatch();
  const list = useAppSelector((state) => state.master.customerEstimatedRankList);

  const [name, setName] = useState('');
  const [abbreviation, setAbbreviation] = useState('');
  const [backGround, setBackGround] = useState('');
  const [textColor, setTextColor] = useState('');
  const [validFlag, setValidFlag] = useState(true);

  const [touch, setTouch] = useState(false);

  const handleClickPost = useCallback(() => {
    if (MasterCustomerExpectedRankValidation(
      name,
      abbreviation,
      backGround,
      textColor,
    )) {
      dispatch(DialogActions.pushMessage({
        title: '顧客見込みランク 編集／追加',
        message: Message.postError,
        callback: () => setTouch(true),
      }));
      return;
    }

    dispatch(MasterActions.api.customerExpectedRank.post({
      param: {
        data: {
          name,
          abbreviation,
          background_color: backGround,
          text_color: textColor,
          is_valid: validFlag ? 1 : 0,
        },
        id,
      },
      onSuccess: () => callback(),

      onError: () => setTouch(true),
    }));
  }, [
    name,
    abbreviation,
    backGround,
    textColor,
    validFlag,
  ]);

  useDidMount(() => {
    if (id) {
      const data = list.find((f) => Number(f.id) === id);
      if (!data) return;
      setName(data.name);
      setAbbreviation(data.abbreviation);
      setValidFlag(data.valid_flag);
      setTextColor(data.text_color);
      setBackGround(data.background_color);
    }
  });

  useEffect(() => { }, []);

  return (
    <EditPC mode="dialog" callback={handleClickPost} label={id ? '更新' : '登録'}>
      <div className="edit_pc_body_inner edit_master customer_expected_rank_master">
        <div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">顧客見込みランク名<Required /></div>
              <Input
                className=""
                value={name}
                onChange={(e) => setName(e.target.value)}
                require
                errorPosBottom
                touch={touch}
                maxLength={10}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">略式表示<Required /></div>
              <Input
                className=""
                value={abbreviation}
                onChange={(e) => setAbbreviation(e.target.value)}
                require
                validationList={ValidationEisuzi}
                touch={touch}
                maxLength={2}
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">背景色<Required /></div>
              {/* <Input
                className=""
                value=""
                onChange={() => {}}
                require
                validationList={ValidationLengthUnder255}
              /> */}
              {/* datepickerと同じようにinput内にアイコンの形にする  */}
              <ColorPicker
                title="カラーピッカー"
                fontAwesomeClass="fas fa-eye-dropper"
                className="secondary"
                color={backGround}
                callbackColor={setBackGround}
                require
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">文字色<Required /></div>
              {/* <Input
                className="color_picker"
                value=""
                onChange={() => {}}
                require
                validationList={ValidationLengthUnder255}
              /> */}
              <ColorPicker
                title="カラーピッカー"
                fontAwesomeClass="fas fa-eye-dropper"
                className="secondary"
                color={textColor}
                callbackColor={setTextColor}
                require
              />
            </div>
          </div>
          <div className="item_wrap">
            <div className="item_box">
              <div className="item_head">有効フラグ</div>
              <RightLabelCheckbox
                label=""
                checked={validFlag}
                className="is_valid"
                onChange={() => setValidFlag(!validFlag)}
              />
            </div>
          </div>
        </div>
      </div>
    </EditPC>
  );
};
